import { render, staticRenderFns } from "./SnsContentTabsParts.vue?vue&type=template&id=7a3098d2&scoped=true"
import script from "./SnsContentTabsParts.vue?vue&type=script&lang=ts"
export * from "./SnsContentTabsParts.vue?vue&type=script&lang=ts"
import style0 from "./SnsContentTabsParts.vue?vue&type=style&index=0&id=7a3098d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3098d2",
  null
  
)

export default component.exports